import { apiClient } from '@/core/api/client';

export interface PersonalInfoData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  addressStreet: string;
  addressNumber: string;
  addressCity: string;
  addressPostalCode: string;
}

export interface PersonalInfoResponse {
  success: boolean;
  data: PersonalInfoData;
}

export interface UpdatePersonalInfoRequest {
  firstName?: string;
  lastName?: string;
  phone?: string;
  addressStreet?: string;
  addressNumber?: string;
  addressCity?: string;
  addressPostalCode?: string;
}

export const personalInfoAPI = {
  /**
   * Get personal information for the current user
   */
  getPersonalInfo: async (): Promise<PersonalInfoData> => {
    try {
      const response = await apiClient.get<PersonalInfoResponse>('/api/admin/mon-espace/personal-info');
      if (response.success && response.data) {
        return response.data;
      }
      throw new Error('Failed to fetch personal information');
    } catch (error) {
      console.error('Error fetching personal info:', error);
      throw error;
    }
  },

  /**
   * Update personal information for the current user
   */
  updatePersonalInfo: async (updates: UpdatePersonalInfoRequest): Promise<{ success: boolean }> => {
    try {
      const response = await apiClient.put<{ success: boolean; message: string }>(
        '/api/admin/mon-espace/personal-info',
        updates
      );
      return { success: response.success };
    } catch (error) {
      console.error('Error updating personal info:', error);
      throw error;
    }
  }
};
